Ext.define('SA.data.LocationSearchQuery', {
    alias: 'query.location-search',
    extend: 'SA.data.Query',

    createParams() {
        var data = {
            fields: this.fields,
            geographicUnits: this.geographicUnits,
            slice: [this.start, this.limit]
        };

        if (this.address) {
            data.address = this.address;
        }

        if (this.censusReleases) {
            data.censusReleases = this.censusReleases;
        }

        if (this.geographicReleases) {
            data.geographicReleases = this.geographicReleases;
        }

        if (this.prefix) {
            data.prefix = this.prefix;
        }

        return {method: 'find', resource: 'locations', data};
    }
});